import checkout from "./form";

const {
  formField: {
    numberOfRegistrations,
    invoiceSymbol,
    status,
    used,
    name,
    from,
    to,
    dayActive,
    invoiceSample,
    supplierName,
    supplierTaxCode,
  },
} = checkout;

const initialValues = {
  [invoiceSymbol.name]: "",
  [numberOfRegistrations.name]: "",
  [status.name]: "",
  [used.name]: "",
  [name.name]: "",
  [from.name]: "",
  [to.name]: "",
  [dayActive.name]: "",
  [invoiceSample.name]: "",
  [supplierName.name]: "",
  [supplierTaxCode.name]: "",
};

export default initialValues;
